export default __webpack_public_path__ + "static/media/pammContentIcon2.0357f2ba.webp";